import type { UploadedFileMeta } from '../store/chatSlice';
import type { ChatContentItem } from './chat.service';
import { utf8ToBase64 } from './base64.utils';

export const TRANSLATION_SUPPORTED_FORMATS_LABEL = 'TXT, PDF, Word, Excel, PPTX, CSV, MSG';
export const TRANSLATION_SUPPORTED_EXTENSIONS_LABEL = '.txt, .pdf, .csv, .docx, .pptx, .xlsx, .msg';
export const TRANSLATION_SUPPORTED_ACCEPT = '.txt,.html,.csv,.docx,.pptx,.pdf,.msg,.xlsx,text/plain,text/html,text/csv,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.presentationml.presentation,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-outlook';

function inferMimeType(fileName: string, fileType?: string) {
  if (fileType) return fileType;

  const ext = fileName.split('.').pop()?.toLowerCase();
  switch (ext) {
    case 'txt':
      return 'text/plain';
    case 'html':
    case 'htm':
      return 'text/html';
    case 'csv':
      return 'text/csv';
    case 'pdf':
      return 'application/pdf';
    case 'doc':
      return 'application/msword';
    case 'docx':
      return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
    case 'ppt':
      return 'application/vnd.ms-powerpoint';
    case 'pptx':
      return 'application/vnd.openxmlformats-officedocument.presentationml.presentation';
    case 'xls':
      return 'application/vnd.ms-excel';
    case 'xlsx':
      return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    case 'msg':
      return 'application/vnd.ms-outlook';
    default:
      return 'application/octet-stream';
  }
}

function isStoredAsPlainText(fileName: string, mimeType: string) {
  return /\.(txt|csv|html?)$/i.test(fileName)
    || mimeType === 'text/plain'
    || mimeType === 'text/csv'
    || mimeType === 'text/html';
}

export function buildTranslationMessageContent(
  uploadedFiles: UploadedFileMeta[],
  messageText: string,
): ChatContentItem[] {
  const fileItems = uploadedFiles.map((uploadedFile) => {
    const mimeType = inferMimeType(uploadedFile.name, uploadedFile.type);
    const base64Payload = isStoredAsPlainText(uploadedFile.name, mimeType)
      ? utf8ToBase64(uploadedFile.data || '')
      : uploadedFile.data || '';

    return {
      type: 'input_file' as const,
      filename: uploadedFile.name,
      file_data: `data:${mimeType};base64,${base64Payload}`,
    };
  });

  return [
    ...fileItems,
    {
      type: 'input_text',
      text: messageText,
    },
  ];
}